
export const getConferenceUserParams = (conference, avatarsData, localAvatar, is_conference_active) => {
    
    
    const safeParticipants = Array.isArray(conference?.participants) && Array.isArray(conference.participants[0])
        ? conference.participants[0]
        : (conference?.participants || []);

   const joinedParticipants = safeParticipants.filter(p => avatarsData[p.user_id]) 
        .map(p => {
            const avatar = avatarsData[p.user_id] || {};
            const initials = avatar.firstName && avatar.lastName
                ? `${avatar.firstName[0]}${avatar.lastName[0]}`.toUpperCase()
                : (p.email ? p.email[0].toUpperCase() : "?");

            return {
                ...p,
                ...avatar,
                conference_user_id: p.id,
                initials
            };
        });

    const myUser = joinedParticipants.find(p => p.user_id === localAvatar?.id);
    const externalGuestEmails = joinedParticipants
    .filter(p => p.role === "guest_externe")
    .map(p => p.email);
    const isAccessTypeRoom = is_conference_active && 
                    myUser?.role === "guest_externe" &&
                    myUser?.access_type === 'room';

    return { joinedParticipants, myUser, isAccessTypeRoom ,externalGuestEmails };
};